import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const RPublication = () => {

    return (
        <section>

            <h2 className="mb-4 text-black">Publication</h2>

        </section>
    );
};

export default RPublication;